import { PasoCooler } from '../../arma-pc/services/PasoCooler';
import { PasoDisco } from '../../arma-pc/services/PasoDisco';
import { PasoFuente } from '../../arma-pc/services/PasoFuente';
import { PasoGabinete } from '../../arma-pc/services/PasoGabinete';
import { PasoMemoria } from '../../arma-pc/services/PasoMemoria';
import { PasoMonitor } from '../../arma-pc/services/PasoMonitor';
import { PasoMother } from '../../arma-pc/services/PasoMother';
import { PasoPerifericos } from '../../arma-pc/services/PasoPerifericos';
import { PasoVideo } from '../../arma-pc/services/PasoVideo';
import { PasoProcesador } from '../../arma-pc/services/PasoProcesador';
import { Product } from './piramide/Product';

export class DatosArmado {
  cpu: PasoProcesador;
  mother: PasoMother;
  ccpu: PasoCooler;
  mem: PasoMemoria;
  video: PasoVideo;
  hd: PasoDisco;
  fuente: PasoFuente;
  gab: PasoGabinete;
  monitores: PasoMonitor;
  perifericos: PasoPerifericos;
  constructor(
    cpu: PasoProcesador,
    mother: PasoMother,
    ccpu: PasoCooler,
    mem: PasoMemoria,
    video: PasoVideo,
    hd: PasoDisco,
    fuente: PasoFuente,
    gab: PasoGabinete,
    monitores: PasoMonitor,
    perifericos: PasoPerifericos,
  ) {
    (this.cpu = cpu),
      (this.mother = mother),
      (this.ccpu = ccpu),
      (this.mem = mem),
      (this.video = video),
      (this.hd = hd),
      (this.fuente = fuente),
      (this.gab = gab),
      (this.monitores = monitores),
      (this.perifericos = perifericos);
  }

  public productStep(producto: Product): string {
    switch (producto.id_subcategoria) {
      case 48:
      case 27:
        return 'cpu';
      case 49:
      case 26:
        return 'mother';
      case 36:
        return 'ccpu';
      case 15:
      case 47:
        return 'mem';
      case 6:
      case 62:
        return 'video';
      case 81:
      case 19:
        return 'hd';
      case 34:
        return 'fuente';
      case 7:
        return 'gab';
      case 5:
        return 'monitores';
      default:
        return 'perifericos';
    }
  }

  vaciarObjeto() {
    for (const propiedad of Object.keys(this)) {
      this[propiedad].lista_productos?.forEach((producto) => {
        producto.cantidad = 0;
        producto.incompatibilities = [];
      });
      this[propiedad].productoSeleccionado = [];
      this[propiedad].productoIncompatible = [];
      this[propiedad].seleccionado = false;
      this[propiedad].productoInvalido = false;
      this[propiedad].lleno = false;
      this[propiedad].productoSinStock = false;
    }
  }
}
